import { setOrganizationConfigs } from '../env/env.slice';
import { OneApi } from '../../components/one-api/one-api';
import { createQueryEndpoint } from '../requests/helpers';
import type { GetConfigsParams, OrganizationConfigs } from '@sydle/ui-api';

export const OrganizationEndpoints = {
  getConfigs: createQueryEndpoint<GetConfigsParams | void, OrganizationConfigs>('OrganizationAPI.getConfigs', {
    async queryFn(params: GetConfigsParams, { dispatch }) {
      const orgId = params?._id || OneApi.restService.config.org;
      return await OneApi.organizationAPI.getConfigs({ ...params, _id: orgId }).then((response) => {
        dispatch(setOrganizationConfigs(response.data));
        return response;
      });
    },
  }),
};
